<template>
    <!-- 请自行调节 Tool -->
    <div class="home-view-product">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(product, index) in productList" :key="index">
                    <div class="container">
                        <div class="left btn-box u-m-r-24">
                            <img class="first-box-icon" :src="product.list[0].img" alt="">
                            <div class="line-1 bold font-28 u-m-t-55 u-m-b-26">{{ product.list[0].name }}</div>
                            <div class="line-1">{{ product.list[0].sub }}</div>
                        </div>
                        <div class="right">
                            <div class="right-box btn-box" v-for="(item, index) in product.list.filter((el, k) => k)" :key="index">
                                <img class="first-box-icon" :src="item.img" alt="">
                                <div class="u-m-l-15">
                                    <div class="line-1 bold font-28 u-m-b-26">{{ item.name }}</div>
                                    <div class="line-1">{{ item.sub }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// 删除未使用的导入
import Swiper from 'swiper';

export default {
    name: 'HomeViewProduct',
    data() {
        return {
            productList: [
                {
                    list: [
                        {
                            name: '成员轻松管理',
                            sub: '管理效率高',
                            img: require('@/assets/home/chengy-icon.png'),
                        },
                        {
                            name: '分级组织架构',
                            sub: '多企业多项目部分级组织架构',
                            img: require('@/assets/home/fenji-icon.png'),
                        },
                        {
                            name: 'SSO单点登录',
                            sub: '方便快捷的用户登录方式 拷贝',
                            img: require('@/assets/home/sso-icon.png'),
                        },
                        {
                            name: '成员帐号管理',
                            sub: '支持集中式管理成员帐号',
                            img: require('@/assets/home/cyzhao-icon.png'),
                        },
                        {
                            name: '精细权限管理',
                            sub: '权限控制更加灵活、精准',
                            img: require('@/assets/home/jingxiqx-icon.png'),
                        },
                    ]
                },
                {
                    list: [
                        {
                            name: '成员轻松管理',
                            sub: '管理效率高',
                            img: require('@/assets/home/chengy-icon.png'),
                        },
                        {
                            name: '分级组织架构',
                            sub: '多企业多项目部分级组织架构',
                            img: require('@/assets/home/fenji-icon.png'),
                        },
                        {
                            name: 'SSO单点登录',
                            sub: '方便快捷的用户登录方式 拷贝',
                            img: require('@/assets/home/sso-icon.png'),
                        },
                        {
                            name: '成员帐号管理',
                            sub: '支持集中式管理成员帐号',
                            img: require('@/assets/home/cyzhao-icon.png'),
                        },
                        {
                            name: '精细权限管理',
                            sub: '权限控制更加灵活、精准',
                            img: require('@/assets/home/jingxiqx-icon.png'),
                        },
                    ]
                },
                {
                    list: [
                        {
                            name: '成员轻松管理',
                            sub: '管理效率高',
                            img: require('@/assets/home/chengy-icon.png'),
                        },
                        {
                            name: '分级组织架构',
                            sub: '多企业多项目部分级组织架构',
                            img: require('@/assets/home/fenji-icon.png'),
                        },
                        {
                            name: 'SSO单点登录',
                            sub: '方便快捷的用户登录方式 拷贝',
                            img: require('@/assets/home/sso-icon.png'),
                        },
                        {
                            name: '成员帐号管理',
                            sub: '支持集中式管理成员帐号',
                            img: require('@/assets/home/cyzhao-icon.png'),
                        },
                        {
                            name: '精细权限管理',
                            sub: '权限控制更加灵活、精准',
                            img: require('@/assets/home/jingxiqx-icon.png'),
                        },
                    ]
                }
            ],
        }
    },
    mounted() {
        new Swiper('.swiper-container', {
            loop: true,
            loopedSlides: 2,
            // initialSlide: 1,
            // watchSlidesProgress: true,
            effect: 'coverflow',
            slidesPerView: '2',
            centeredSlides: true,
            spaceBetween: '-50%',
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 4,
                slideShadows: false,
            },

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
        
    }
}
</script>
<style lang="scss" scoped>
.home-view-product {
    width: 1550px;
    position: relative;
    left: -165px;
    // .swiper-slide {
    //     width: 1220px !important;
    // }

    color: #333;

    .swiper-slide {
        .container {
            width: 1140px;
            height: calc(100% - 86px);
            padding: 43px 40px;
            display: flex;
            align-items: center;
            box-shadow: 0px 0px 18px 0px rgba(18,87,174,0.14);
            border-radius: 24px;
            background: #FFFFFF;
        }
        .left {
            width: 308px;
            height: 428px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
        .right {
            flex: 1;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px 24px;
            &-box {
                display: flex;
                align-items: center;
                padding: 32px 0 42px 18px;
            }
        }
        .first-box-icon {
            height: 130px;
        }
    }
    .btn-box {
        background: linear-gradient(0deg, #E7F4FC 0%, #D8EDFF 100%);
        border-radius: 24px;
    }
    .radius-box {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        width: 280px;
        height: 400px;
        flex-direction: column;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: transform 0.3s ease;
        &:hover {
            transform: translateY(-5px);
        }
        .first-box-icon {
            height: 96px;
            margin-bottom: 20px;
        }
        .bold {
            font-size: 24px;
            margin: 20px 0 10px;
        }
    }
}
</style>